import { useState } from "react";
import { useAuth } from "../../../context/AuthContext";
import { useNavigate, useParams } from "react-router-dom";
import { IoIosArrowRoundBack } from "react-icons/io";
import QuestionSection from "../../ui/QuestionSection/QuestionSection";
import CommonFooter from "../../CommonFooter/CommonFooter";
import CommonButton from "../../ui/CommonButton/CommonButton";
import classes from "./GeneralRequirements.module.css";
import { useAccreditation } from "../../../hooks/useAccreditation";

const GeneralRequirements = () => {
  const { labId } = useParams();
  const { user, token } = useAuth();
  const navigate = useNavigate();
  const [currentSet, setCurrentSet] = useState(0);
  const [isEditing, setIsEditing] = useState(false)

  const { formData, setFormData, loading, hydrated, fetching, editable, setEditable, handleDone } =
    useAccreditation({
      labId,
      section: "General requirements",
      name: "SADCAS F134-A",
      auditorId: user._id,
      isAssessor: user.role === "ASSESSOR",
      isEditing,
      token,
    });

  const handleAnswerChange = (questionId, score, comment, points, content) => {
    setFormData((prev) => ({
      ...prev,
      [questionId]: { score, comment, points, content },
    }));
  };

  const questionSets = [
    {
      questions: [
        {
          questionId: "Q1",
          content:
            "Are laboratory activities undertaken impartially? How is the laboratory structured and managed to safeguard impartiality?",
          number: "a",
          multiline: true,
          placeholder: "Add comment",
        },
        {
          questionId: "Q2",
          content:
            "What evidence is available to show management’s commitment to impartiality?",
          number: "b",
          multiline: true,
          placeholder: "Add comment",
        },
        {
          questionId: "Q3",
          content:
            "What measures are in place to ensure that the laboratory takes responsibility for impartiality and avoids pressures?",
          number: "c",
          multiline: true,
          placeholder: "Add comment",
        },
      ],
      render: (onAnswerChange, answers) => (
        <QuestionSection
          number="4.1"
          title="Impartiality"
          accreditation
          showPointsField={false}
          questions={questionSets[0].questions}
          onAnswerChange={editable ? onAnswerChange : () => {}}
          answers={answers}
          disabled={!editable}
        />
      ),
    },
  ];

  const handleNext = () => {
    if (currentSet < questionSets.length - 1) setCurrentSet((prev) => prev + 1);
  };

  const handlePrevious = () => {
    if (currentSet > 0) setCurrentSet((prev) => prev - 1);
  };

  if (!hydrated || fetching) {
    return <div className={classes.loading}>Loading...</div>;
  }

  return (
    <div className={`${classes.wrapper} ${!editable ? classes.fromParams : ""}`}>
      <div className="d-flex justify-content-between align-items-center">
        <div
          className="d-flex align-items-center gap-2 mb-4"
          onClick={() => navigate(-1)}
          role="button"
        >
          <IoIosArrowRoundBack size={35} />
          <h2 className="m-0">Clause 4: General Requirements</h2>
        </div>

        {user.role === "ASSESSOR" && !editable && (
          <CommonButton
            className={classes.editButton}
            onClick={() => { setIsEditing(true); setEditable(true); }} // triggers edit mode
            title="Edit"
          />
        )}
      </div>

      {!editable ? (
        <div className={classes.infoText}>
          ✅ Your SADCAS A - Clause 4: General Requirements has been submitted.
        </div>
      ) : (
        questionSets[currentSet].render(handleAnswerChange, formData)
      )}

      {editable && (
        <CommonFooter
          handlePrevious={handlePrevious}
          handleNext={handleNext}
          handleDone={handleDone}
          cancelText="Cancel"
          handleCancel={() => {
            setEditable(false);
          }}
          currentSet={currentSet}
          questionSets={questionSets}
          doneText={loading ? "Submitting..." : "Update"}
          disabled={loading}
        />
      )}
    </div>
  );
};

export default GeneralRequirements;